import { useState, useEffect, useCallback } from 'react';
import { BACKEND_URL } from '../config';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';

export const useLocalization = () => {
  const [language, setLanguage] = useState('en');
  const [texts, setTexts] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { token, userType } = useAuth();

  // Fetch client settings to get the language
  useEffect(() => {
    const fetchLanguageAndTexts = async () => {
      setLoading(true);
      setError(null);
      try {
        let clientLocale = 'en';
        
        if (userType === 'admin') {
          // For admin users, use English by default
          clientLocale = 'en';
        } else {
          // For client users, get client settings to determine language
          const settingsResponse = await axios.get('/client-settings/', {
            headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json'
            }
          });
          clientLocale = settingsResponse.data?.localization || 'en';
        }
        
        setLanguage(clientLocale);
        
        // Fetch localization texts for the determined language
        let textsResponse;
        if (userType === 'admin') {
          // Use the language-specific endpoint for admin users
          textsResponse = await axios.get(`/localization/texts/${clientLocale}`, {
            headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json'
            }
          });
        } else {
          // Use client endpoint for client users
          textsResponse = await axios.get('/localization/texts', {
            headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json'
            }
          });
        }
        
        const textsData = textsResponse.data.texts || {};
        setTexts(textsData);
      } catch (err) {
        console.error('Localization error:', err);
        setError(err.message);
        setTexts({});
      } finally {
        setLoading(false);
      }
    };
    fetchLanguageAndTexts();
  }, [token, userType]);

  // Get localized text
  const t = useCallback((key, fallback = null) => {
    
    const text = texts[key];
    if (text !== undefined) {
      return text;
    }
    if (fallback === null) {
      return key;
    }
    return fallback;
  }, [texts, language]);

  return {
    t,
    language,
    loading,
    error,
    reloadTexts: () => window.location.reload()
  };
}; 